'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { Camera, ArrowRight, ShieldCheck, Zap, Image, Sparkles } from 'lucide-react';

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const token = localStorage.getItem('access_token');
      if (token) {
        router.push('/dashboard');
      }
    }
  }, [router]);

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100 flex flex-col justify-between">
      {/* Header */}
      <header className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
        <div className="flex items-center space-x-2 text-white font-extrabold text-xl">
          <div className="bg-amber-500 p-2 rounded-xl text-neutral-950">
            <Camera className="w-5 h-5" />
          </div>
          <span>Foto<span className="text-amber-500">Studio</span></span>
        </div>

        <div className="flex items-center space-x-3">
          <Link
            href="/login"
            className="px-4 py-2 text-sm font-medium text-neutral-300 hover:text-white transition-colors"
          >
            Entrar
          </Link>
          <Link
            href="/register"
            className="px-4 py-2 bg-amber-500 hover:bg-amber-400 text-neutral-950 font-bold text-sm rounded-xl transition-all shadow-lg shadow-amber-500/20"
          >
            Cadastrar Estúdio
          </Link>
        </div>
      </header>

      {/* Hero */}
      <main className="max-w-5xl mx-auto px-4 text-center py-16 sm:py-24 space-y-6">
        <div className="inline-flex items-center space-x-2 px-3.5 py-1.5 rounded-full bg-neutral-900 border border-neutral-800 text-neutral-300 text-xs font-semibold">
          <Sparkles className="w-4 h-4 text-amber-500" />
          <span>SaaS Especializado para Fotógrafos Profissionais</span>
        </div>

        <h1 className="text-4xl sm:text-6xl font-black text-white tracking-tight leading-tight">
          Prova, Seleção e Cobrança PIX <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">
            Sem Upload Desnecessário de Originais
          </span>
        </h1>

        <p className="max-w-2xl mx-auto text-neutral-400 text-sm sm:text-base leading-relaxed">
          Envie apenas previews com marca d'água direto para o Cloudflare R2. O cliente escolhe as fotos, paga os excedentes via PIX Mercado Pago e você edita e entrega somente as fotos selecionadas.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
          <Link
            href="/register"
            className="w-full sm:w-auto flex items-center justify-center space-x-2 px-8 py-3.5 bg-amber-500 hover:bg-amber-400 text-neutral-950 font-extrabold rounded-xl text-base shadow-xl shadow-amber-500/25 transition-all"
          >
            <span>Começar Gratuitamente</span>
            <ArrowRight className="w-5 h-5" />
          </Link>
          <Link
            href="/login"
            className="w-full sm:w-auto px-8 py-3.5 bg-neutral-900 hover:bg-neutral-800 text-white font-bold rounded-xl text-base border border-neutral-800 transition-colors"
          >
            Acessar Meu Painel
          </Link>
        </div>

        {/* Feature Highlights */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-16 text-left">
          <div className="bg-neutral-900/60 border border-neutral-800 p-6 rounded-2xl space-y-2">
            <Zap className="w-6 h-6 text-amber-400" />
            <h3 className="font-bold text-white text-base">Zero Desperdício de Banda</h3>
            <p className="text-xs text-neutral-400 leading-relaxed">
              Não envie gigabytes de RAW ou originais antes da seleção. Apenas provas leves com marca d'água.
            </p>
          </div>

          <div className="bg-neutral-900/60 border border-neutral-800 p-6 rounded-2xl space-y-2">
            <ShieldCheck className="w-6 h-6 text-emerald-400" />
            <h3 className="font-bold text-white text-base">Cobrança PIX Automática</h3>
            <p className="text-xs text-neutral-400 leading-relaxed">
              Cálculo seguro no backend com QR Code instantâneo do Mercado Pago e liberação por webhook.
            </p>
          </div>

          <div className="bg-neutral-900/60 border border-neutral-800 p-6 rounded-2xl space-y-2">
            <Image className="w-6 h-6 text-blue-400" />
            <h3 className="font-bold text-white text-base">Entrega Segura no R2</h3>
            <p className="text-xs text-neutral-400 leading-relaxed">
              Armazenamento privado no Cloudflare R2 com URLs temporárias de download e integração Lightroom.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-850 py-6 text-center text-xs text-neutral-500">
        FotoStudio SaaS • Desenvolvido para fotógrafos de alta performance
      </footer>
    </div>
  );
}
